import { useContext, useEffect } from 'react';

import Files from 'react-files';
import JSZip from 'jszip';
import React from 'react';
import Roster from '../../helpers/Roster';
import { RosterContext } from '../../context/context';
import XMLParser from 'react-xml-parser';
import {testRoster} from '../../teams/test';

const Uploader = () => {
  const { setRoster } = useContext(RosterContext);

  // useEffect(() => {
  //   setRoster((currentState) => testRoster);
  // });

  const onFileChange = (files) => {
    const zip = new JSZip();
    const parser = new XMLParser();
    zip.loadAsync(files[0]).then((zipData) => {
      const fileName = Object.keys(zipData.files)[0];
      zip.file(fileName).async('string').then((content) => {
        setRoster(new Roster(parser.parseFromString(content)));
      })
    });
  }

  const onFileError = (error, file) => {
    console.log('ERROR', error.message);
  }

  return (<form>
    <Files
      className='files-dropzone'
      onChange={onFileChange}
      onError={onFileError}
      accepts={['.rosz']}
      clickable>
      Upload .rosz file
    </Files>
  </form>);
};

export default Uploader;
